import React from 'react'
import {withStyles} from 'material-ui'
import classNames from 'classnames'

import MainNav from './MainNav'


const styles = theme => ({
    root: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100vw',
        backgroundColor: theme.palette.hero,
        backgroundSize: 'cover',
        height: theme.layout.heroTotalHeight,
        zIndex: -1,
    },
    overlay: {
        width: '100%',
        height: '100%',
    },
})

export const Cover = withStyles(styles)(
    ({classes, className='', src, dark, children}) => (
        <div
                className={classNames(classes.root, className)}
                style={{backgroundImage: `url(${src})`}}>
            <div
                className={classes.overlay}
                style={{backgroundColor: `rgba(0, 0, 0, ${dark}`}}/>
        </div>
    )
)

export default Cover


// WEBPACK FOOTER //
// ./src/components/Cover.jsx